import { Arrange, Button, Logo as LoomLogo, Text } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useFlagIsActivated } from 'hooks/featureFlag';
import { invokeSharedAuthFlow } from 'utilities/slack/sharedAuthHandler';
import {
  selectCurrentVideoId,
  selectIsFromSlackDesktopApp,
} from 'selectors/videoPlayer';

import { ROLLOUT_SLACK_SHARED_AUTH_PUBLIC } from 'constants/featureFlag';

import styles from './styles.module.less';

export enum SharedAuthSource {
  PUBLIC_REACTION = 'public reaction',
  PUBLIC_COMMENT = 'public comment',
}

type SharedAuthButtonProps = {
  source: SharedAuthSource;
  isCollapsed: boolean;
};

export const SharedAuthButton = ({
  source,
  isCollapsed,
}: SharedAuthButtonProps): JSX.Element | null => {
  const rolloutSlackSharedAuthPublic = useFlagIsActivated({
    flag: ROLLOUT_SLACK_SHARED_AUTH_PUBLIC,
    activationValues: [true],
  });

  const isFromSlackDesktopApp = useSelector(selectIsFromSlackDesktopApp);
  const videoId = useSelector(selectCurrentVideoId);

  if (!rolloutSlackSharedAuthPublic || !isFromSlackDesktopApp) {
    return null;
  }

  return (
    <Button
      className={classNames(styles.sharedAuthButton, {
        [styles.sharedAuthButtonCollapsed]: isCollapsed,
      })}
      onClick={() => invokeSharedAuthFlow(videoId, source, true)}
      size="small"
    >
      <Arrange gap="xsmall">
        <LoomLogo variant="symbol" maxWidth={3} />
        <Text className={styles.sharedAuthText} size="small">
          Connect using Loom
        </Text>
      </Arrange>
    </Button>
  );
};
